<script lang="ts" setup>
import type {Component} from 'vue';

const props = defineProps<{
  icon: Component,
  iconSize?: string,
  title: string,
}>();

// const iconColor = props.iconColor ?? 'var(--foreground)#ffffff';
const iconSize = props.iconSize ?? '24px';
</script>
<template>
  <li>
    <div class="flex items-center gap-3">
      <div class="mt-1 text-foreground">
        <component :is="icon" :size="iconSize"/>
      </div>
      <div>
        <h3 class="font-semibold">{{ title }}</h3>
      </div>
    </div>
  </li>
</template>
